import React from 'react';
import { LayoutProps } from './layout';
import { EnrollmentLayout } from './enrollment-layout';

interface BannerLayoutProps extends LayoutProps {
	title?: string;
}

export const BannerLayout: React.FC<BannerLayoutProps> = ({
    children,
    mlrVersion,
    title,
    label
}) => {
    return (
        <EnrollmentLayout
            label={label}
            title={title}
            mlrVersion={mlrVersion}
            isBackButton={false}
        >
            {children}
        </EnrollmentLayout>
    );
}